import { render } from "./ReplyPostContents.vue?vue&type=template&id=4091c9a5&ts=true"
import script from "./ReplyPostContents.vue?vue&type=script&lang=ts&setup=true"
export * from "./ReplyPostContents.vue?vue&type=script&lang=ts&setup=true"

import "./ReplyPostContents.vue?vue&type=style&index=0&id=4091c9a5&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/communityTalk/reply/ReplyPostContents.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4091c9a5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4091c9a5', __exports__)) {
    api.reload('4091c9a5', __exports__)
  }
  
  module.hot.accept("./ReplyPostContents.vue?vue&type=template&id=4091c9a5&ts=true", () => {
    api.rerender('4091c9a5', render)
  })

}


export default __exports__